<template>
    <div class="row" role="group" aria-label="location">
        <div class="col-8">
            <div class="address-block">
              <h2 class="h5 name">
                <!-- <button type="button" v-on:click.stop="selectLocationClick(location)" class="h5 name">{{ location.name }}</button> -->
                <a v-bind:href="location.locationUrl" class="h5 name">{{ location.name }}</a>
            </h2>
                <span v-html="address"></span>
                <a v-if="location.phone" v-bind:href="telephone" class="tel">{{ location.phone }}</a>
            </div>
        </div>
        <div class="col-4">
            <div v-if="location.distance > 0" class="distance">{{ distance }}</div>
            <div v-if="location.notice" class="notice">
                <img class="icon" src="/Static/assets/images/notice_icon.png" alt="" />
                {{ text("notice") }}
            </div>
        </div>
      
        <div class="col-12">
            <results-item-hours
                :heading="location.isAtm ? text('availability') : text('lobby')"
                :location="location"
                :hours="location.lobbyHours"
                :idcontrol="location.id"
            ></results-item-hours>

            <results-item-hours
                :heading="text('driveThru')"
                :location="location"
                :hours="location.driveThruHours"
                :idcontrol="location.id"
            ></results-item-hours>

            <div class="hours-block" v-if="location.driveUpAtm">
                <h3 class="heading">{{ text("driveUpAtm") }}</h3>
                <div class="now nodetails" v-html="location.driveThruAtmHours"></div>
            </div>

            <div class="hours-block" v-if="location.walkUpAtm">
                <h3 class="heading">{{ text("walkUpAtm") }}</h3>
                <div class="now nodetails" v-html="location.walkUpAtmHours"></div>
            </div>

            <div class="services-block" v-if="services">
                <span class="heading">{{ text("services") }}</span>
                {{ servicesString }}
            </div>

            <div class="directions-block">
                <a v-bind:href="directions" target="_blank" class="link"><img src="/static/assets/images/directions_icon.svg" alt="" />{{ text("directions") }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "../functions/eventBus";
import Hours from "./ResultsItemHours.vue";
import { locText } from "../../../utils/useText";
import * as resultsFunctions from "../functions/results";

export default {
    data() {
        return {
            
        }
    },
    components: {
        "results-item-hours": Hours
    },
    computed: {
        address() {
            return resultsFunctions.formatAddress(this.location);
        },        
        directions() {
            let loc = this.$store.state.userSearch;
            if (!loc.lat && !loc.lng)
                loc = this.$store.state.userLocation;

            return resultsFunctions.formatDirectionsLink(this.location, loc);
        },
        distance() {
            return parseFloat(this.location.distance).toFixed(1) + " " + this.text("distance");
        },
        services() {
            return resultsFunctions.hasServices(this.location);
        },
        servicesString() {
            return resultsFunctions.formatServicesString(this.location);
        },
        telephone() {
            return resultsFunctions.formatTelephone(this.location);
        }
    },
    mixins: [locText],
    props: {
        location: Object,
        selectLocationClick: Function
    }
}
</script>
